<template>
  <div>
    <div>
      <PopupRelease
        v-for="release in releases"
        :key="release.id"
        :release="release"
        v-show="showRelease == release.id"
        @closePopup="closePopup"
      ></PopupRelease>
    </div>
  </div>
</template>

<script>
import PopupRelease from "./PopupRelease";
import releases from "./releases_infos.js";
export default {
  name: "Console",
  components: {
    PopupRelease,
  },
  props: ["showRelease"],
  data() {
    return {
      releases: releases,
    };
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
  },
};
</script>

<style lang="scss" scoped></style>
